import { BiLink } from "react-icons/bi";
import ProjectWindow from "../../components/ProjectWindow/ProjectWindow";
import { useGlobalContext } from "../../context";
import "./projects.css";

const Projects = () => {
  const { projects } = useGlobalContext();

  return (
    <>
      <div className="projectsPageContainer">
        <h1 className="projectPageHead fadeDown">
          Here are some of my projects!
        </h1>
        <div className="projectsPage">
          {projects.map((project, i) => {
            return (
              <ProjectWindow
                project={project}
                key={project.id}
                style={{ animationDelay: `${i + 1}00ms` }}
              />
            );
          })}
        </div>
        <a
          className="projectPageMessageContainer"
          href="https://github.com/SonuBardai?tab=repositories"
          target="_blank"
          rel="noreferrer"
        >
          <p className="projectPageMessage">
            PS: There's more! You can check out my other projects here
          </p>
          <BiLink className="projectLinkIcon" />
        </a>
      </div>
    </>
  );
};

export default Projects;
